import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../shared/utility";

const initialState = {
  countries: [],
  loading: false,
  selectedCountry: null,
  leagueInformation: [],
  leagueId: null,
  selectedLeague: {},
  leagueTable: [],
  teamsForLeague: [],
  teamId: null,
  selectedTeam: {},
  playersForTeam: [],
  fixtures: [],
  userActivity: [],
  liveScore: [],
  fixture: [],
  players: [],
  topScorers: []
};

const fetchCountries = (state, action) => {
  return updateObject(state, {
    countries: action.countries
  });
};

const fetchCountriesSuccess = (state, action) => {
  return updateObject(state, {
    countries: action.countries,
    loading: false
  });
};

const fetchCountriesStart = (state, action) => {
  return updateObject(state, { loading: true });
};

const fetchCountriesFail = (state, action) => {
  return updateObject(state, { loading: false });
};

const selectCountry = (state, action) => {
  return updateObject(state, {
    selectedCountry: action.countryName
  });
};

const fetchLeagueInformation = (state, action) => {
  return updateObject(state, {
    leagueInformation: action.leagueInformation
  });
};

const fetchLeagueInformationStart = (state, action) => {
  return updateObject(state, { loading: true });
};

const fetchLeagueInformationSuccess = (state, action) => {
  return updateObject(state, {
    leagueInformation: action.leagueInformation,
    loading: false
  });
};

const selectLeague = (state, action) => {
  const leagueObject = Object.assign(
    ...state.leagueInformation.filter(el => {
      return el.league_id === action.leagueId;
    })
  );

  return updateObject(state, {
    leagueId: action.leagueId,
    selectedLeague: leagueObject
  });
};

const selectTeam = (state, action) => {
  const teamObject = Object.assign(
    ...state.teamsForLeague.filter(el => {
      return el.team_id === action.teamId;
    })
  );

  return updateObject(state, {
    teamId: action.teamId,
    selectedTeam: teamObject
  });
};

const fetchLeagueTableSuccess = (state, action) => {
  return updateObject(state, {
    leagueTable: action.leagueTable,
    fixtures: action.fixtures,
    loading: false
  });
};

const fetchTeamsForLeagueSuccess = (state, action) => {
  return updateObject(state, {
    teamsForLeague: action.teamsForLeague,
    loading: false
  });
};

const fetchPlayersForTeam = (state, action) => {
  return updateObject(state, {
    playersForTeam: action.playersForTeam
  });
};

const fetchPlayersForTeamSuccess = (state, action) => {
  return updateObject(state, {
    playersForTeam: action.playersForTeam
  });
};

const fetchUserActivityStart = (state, action) => {
  return updateObject(state, { loading: true });
};

const fetchUserActivity = (state, action) => {
  return updateObject(state, {
    userActivity: action.userActivity
  });
};

const fetchUserActivitySuccess = (state, action) => {
  return updateObject(state, {
    userActivity: action.userActivity,
    loading: false
  });
};

const fetchLiveScoreStart = (state, action) => {
  return updateObject(state, { loading: true });
};

const fetchLiveScore = (state, action) => {
  return updateObject(state, {
    liveScore: action.liveScore
  });
};

const fetchLiveScoreSuccess = (state, action) => {
  return updateObject(state, {
    liveScore: action.liveScore,
    loading: false
  });
};

const fetchFixtureStart = (state, action) => {
  // return updateObject(state, { loading: true });
  return updateObject(state);
};

const fetchFixture = (state, action) => {
  return updateObject(state, {
    fixture: action.fixture
  });
};

const fetchFixtureSuccess = (state, action) => {
  return updateObject(state, {
    fixture: state.fixture.concat(action.fixture)
  });
};

const fetchPlayerStart = (state, action) => {
  return updateObject(state, { loading: true });
};

const fetchPlayer = (state, action) => {
  return updateObject(state, {
    player: action.player
  });
};

const fetchPlayerSuccess = (state, action) => {
  return updateObject(state, {
    players: state.players.concat(action.player),
    loading: false
  });
};

const fetchTopScorersForLeague = (state, action) => {
  return updateObject(state, {
    topScorers: action.topScorers
  });
};

const fetchTopScorersForLeagueSuccess = (state, action) => {
  return updateObject(state, {
    topScorers: action.topScorers,
    loading: false
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_COUNTRIES:
      return fetchCountries(state, action);
    case actionTypes.FETCH_COUNTRIES_SUCCESS:
      return fetchCountriesSuccess(state, action);
    case actionTypes.FETCH_COUNTRIES_FAIL:
      return fetchCountriesFail(state, action);
    case actionTypes.FETCH_COUNTRIES_START:
      return fetchCountriesStart(state, action);
    case actionTypes.SELECT_COUNTRY:
      return selectCountry(state, action);
    case actionTypes.FETCH_LEAGUE_INFORMATION:
      return fetchLeagueInformation(state, action);
    case actionTypes.FETCH_LEAGUE_INFORMATION_START:
      return fetchLeagueInformationStart(state, action);
    case actionTypes.FETCH_LEAGUE_INFORMATION_SUCCESS:
      return fetchLeagueInformationSuccess(state, action);
    case actionTypes.SELECT_LEAGUE:
      return selectLeague(state, action);

    case actionTypes.FETCH_LEAGUE_TABLE_START:
      return fetchCountriesStart(state, action);
    case actionTypes.FETCH_LEAGUE_TABLE_SUCCESS:
      return fetchLeagueTableSuccess(state, action);

    case actionTypes.FETCH_TEAMS_FOR_LEAGUE_SUCCESS:
      return fetchTeamsForLeagueSuccess(state, action);
    case actionTypes.SELECT_TEAM:
      return selectTeam(state, action);

    case actionTypes.FETCH_PLAYERS_FOR_TEAM:
      return fetchPlayersForTeam(state, action);
    case actionTypes.FETCH_PLAYERS_FOR_TEAM_SUCCESS:
      return fetchPlayersForTeamSuccess(state, action);

    case actionTypes.FETCH_USER_ACTIVITY_START:
      return fetchUserActivityStart(state, action);
    case actionTypes.FETCH_USER_ACTIVITY:
      return fetchUserActivity(state, action);
    case actionTypes.FETCH_USER_ACTIVITY_SUCCESS:
      return fetchUserActivitySuccess(state, action);

    case actionTypes.FETCH_LIVE_SCORE_START:
      return fetchLiveScoreStart(state, action);
    case actionTypes.FETCH_LIVE_SCORE:
      return fetchLiveScore(state, action);
    case actionTypes.FETCH_LIVE_SCORE_SUCCESS:
      return fetchLiveScoreSuccess(state, action);

    case actionTypes.FETCH_FIXTURE_START:
      return fetchFixtureStart(state, action);
    case actionTypes.FETCH_FIXTURE:
      return fetchFixture(state, action);
    case actionTypes.FETCH_FIXTURE_SUCCESS:
      return fetchFixtureSuccess(state, action);

    case actionTypes.FETCH_PLAYER_START:
      return fetchPlayerStart(state, action);
    case actionTypes.FETCH_PLAYER:
      return fetchPlayer(state, action);
    case actionTypes.FETCH_PLAYER_SUCCESS:
      return fetchPlayerSuccess(state, action);

    case actionTypes.FETCH_TOP_SCORER:
      return fetchTopScorersForLeague(state, action);
    case actionTypes.FETCH_TOP_SCORER_SUCCESS:
      return fetchTopScorersForLeagueSuccess(state, action);

    default:
      return state;
  }
};

export default reducer;
